import { useDeleteMeeting } from '../../api/useDeleteMeeting';
import { DisplayedMeeting } from '../../types';

export function useDeleteMeetingModal(meeting: DisplayedMeeting) {
  const deleteMeeting = useDeleteMeeting();

  // ConfirmDeleteDialog closes on success and surfaces a rejection as a server error.
  function handleConfirm() {
    return deleteMeeting.mutateAsync(meeting.id);
  }

  return {
    handleConfirm,
  };
}
